// extracted by mini-css-extract-plugin
export default {"container":"Dev_indicator_container__84IbU"};